export const heroProfileSelector = state => state.heroProfile.get('heroProfile');
export const heroProfileIsLoadingSelector = state => state.heroProfile.get('isLoading');
export const heroProfileErrorsSelector = state => state.heroProfile.get('errors');
